/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import SectionTitle from "./SectionTitle";
import container from "./container";

export {
  SectionTitle,
  container
};
